const worries = [
  { num: '01', text: '相続した不動産の処分に困っている' },
  { num: '02', text: '空き家の管理が負担になっている' },
  { num: '03', text: '急な現金化が必要になった' },
  { num: '04', text: '近所に知られずに売却したい' },
  { num: '05', text: '住み替えのタイミングで悩んでいる' },
  { num: '06', text: '共有持分の整理をしたい' },
  { num: '07', text: 'いつ売るべきか判断できない' },
  { num: '08', text: '不動産の相場がわからない' },
];

export default function WorriesSection() {
  return (
    <section className="py-20 md:py-28 bg-[#F8F9FB] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left: Image */}
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://public.readdy.ai/ai/img_res/4fe4781fd8840c9e1d4d6c6dc820bd5c.jpg"
                alt="不動産相談のイメージ"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0D1B2E]/30 to-transparent" />
            </div>
            {/* Floating card */}
            <div className="absolute -bottom-6 -right-4 md:-right-8 bg-white rounded-2xl px-6 py-5 w-52">
              <div className="text-3xl font-bold text-[#1A2B4A] mb-1">98<span className="text-lg">%</span></div>
              <div className="text-gray-500 text-xs leading-relaxed">お客様満足度<br />（2024年実績）</div>
              <div className="flex gap-0.5 mt-2">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-xs" />
                ))}
              </div>
            </div>
          </div>

          {/* Right: Content */}
          <div className="order-1 lg:order-2">
            <div className="flex items-center gap-3 mb-6">
              <div className="h-px w-10 bg-emerald-500" />
              <span className="text-emerald-600 text-xs font-semibold tracking-[0.2em] uppercase">Worries</span>
            </div>
            <h2 className="text-[#1A2B4A] text-2xl md:text-4xl font-bold mb-4 leading-tight">
              こんなお悩み<br />ありませんか？
            </h2>
            <p className="text-gray-500 text-sm mb-10 leading-relaxed">
              どんな状況でも、まずはお気軽にご相談ください。<br />
              <strong className="text-[#1A2B4A]">押し売りは一切しません。</strong>
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {worries.map((worry) => (
                <div
                  key={worry.num}
                  className="flex items-center gap-4 bg-white rounded-xl px-5 py-4 hover:shadow-sm transition-shadow duration-200"
                >
                  <span className="text-emerald-500/40 font-bold text-xs tabular-nums flex-shrink-0">{worry.num}</span>
                  <p className="text-[#1A2B4A] text-sm font-medium leading-snug">{worry.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}